var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShoppingCartWhite = function SvgShoppingCartWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22.453 20.345"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.25 -.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 51",
    cx: 1.75,
    cy: 1.75,
    r: 1.75,
    transform: "translate(7.731 17.095)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 52",
    cx: 1.75,
    cy: 1.75,
    r: 1.75,
    transform: "translate(16.309 17.095)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2189",
    d: "M1 1h3.846l2.578 12.752a1.919 1.919 0 0 0 1.923 1.533h9.347a1.919 1.919 0 0 0 1.923-1.533l1.336-9.208H6.281",
    fill: "rgba(0,0,0,0)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
export default SvgShoppingCartWhite;